
import { PORTONE_USER_CODE, PG_PROVIDER } from '../constants';
import { functions, httpsCallable } from '../firebase';

declare global {
  interface Window {
    IMP: any;
  }
}

export interface PaymentData {
  merchant_uid: string;
  name: string;
  amount: number;
  buyer_email: string;
  buyer_name: string;
  buyer_tel: string;
  buyer_addr: string;
  buyer_postcode: string;
}

/**
 * Portone(아임포트) 결제창 호출 함수 - [KG이니시스 기준]
 */
export const requestPayment = (
  data: PaymentData & { m_redirect_url?: string; userId: string },
  onSuccess: (rsp: any) => void,
  onError: (rsp: any) => void
): void => {
  const { IMP } = window;
  if (!IMP) {
    alert('결제 SDK가 로드되지 않았습니다. 페이지를 새로고침해주세요.');
    return;
  }

  // 결제 진입 전 UID 백업 (모바일 브라우저 세션 유실 방어용)
  localStorage.setItem('makerstory_auth_recovery_uid', data.userId);

  // Portone 초기화
  IMP.init(PORTONE_USER_CODE);

  // 모바일 환경 리다이렉트 시 무조건 쇼핑홈(/shop)으로 돌아가도록 설정
  const redirectUrl = data.m_redirect_url || `${window.location.origin}/#/shop`;

  IMP.request_pay(
    {
      pg: PG_PROVIDER, 
      pay_method: 'card', 
      merchant_uid: data.merchant_uid,
      name: data.name,
      amount: data.amount,
      buyer_email: data.buyer_email,
      buyer_name: data.buyer_name,
      buyer_tel: data.buyer_tel,
      buyer_addr: data.buyer_addr,
      buyer_postcode: data.buyer_postcode,
      m_redirect_url: redirectUrl,
      // Cloud Functions에 등록된 결제 결과 처리 웹훅
      notice_url: 'https://asia-northeast3-makerstory-shopping.cloudfunctions.net/inicisReturn', 
      escrow: false,
    },
    (rsp: any) => {
      // PC 환경 콜백 처리
      if (rsp.success) {
        localStorage.removeItem('makerstory_auth_recovery_uid');
        onSuccess(rsp);
      } else {
        localStorage.removeItem('makerstory_auth_recovery_uid');
        onError(rsp);
      }
    }
  );
};

/**
 * 실제 환불(결제 취소) 처리 함수
 */
export const cancelPayment = async (merchant_uid: string, reason: string): Promise<{ success: boolean; message: string }> => {
  try {
    const processRefund = httpsCallable(functions, 'processRefund');
    const response: any = await processRefund({ merchant_uid, reason });

    if (response.data && response.data.success) {
      return { success: true, message: response.data.message || "결제 취소가 완료되었습니다." };
    } else {
      return { success: false, message: response.data.message || "환불 처리 중 거부되었습니다." };
    }
  } catch (error: any) {
    console.error("Cloud Function Error:", error);
    return { success: false, message: `서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요. (${error.message || error})` };
  }
};
